module.exports = __webpack_public_path__ + "static/media/pha-kuang-cave.cbeec330.jpg";